import moment from "moment";

const myMoment = moment;
myMoment.locale("es");

const momentDateTimeFormat = "YYYY-MM-DD HH:mm";
const momentDateFormat = "YYYY-MM-DD";

export { myMoment, momentDateTimeFormat, momentDateFormat };
